module.exports = __webpack_public_path__ + "static/media/spx_logo.2c8a3e55.svg";